module.exports = __webpack_public_path__ + "static/img/Cameron-Munster.88dccb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Cameron-Munster.jpg
// module id = WE7k
// module chunks = 0